import {Tooltip} from 'antd';

import {Locale} from '../../provider/locale/locale';
import {LangKeyType} from '../../provider/locale/translation/type';
import {classNames} from '../../util/css';

import * as styles from './publication-form-layout.scss';

type PropsType = {
    isDisabled: boolean;
    langKey: LangKeyType;
    children: JSX.Element;
};

// Explains why a footer button is disabled. A disabled button fires no mouse events, so the tooltip
// has to be triggered by this wrapper instead.
export function PublicationFooterButtonTooltip(props: PropsType): JSX.Element {
    const {isDisabled, langKey, children} = props;

    return (
        <Tooltip title={isDisabled ? <Locale stringKey={langKey} /> : ''}>
            <span
                className={classNames(styles.PublicationFormLayout_tooltipTarget, {
                    [styles.PublicationFormLayout_tooltipTarget__disabled]: isDisabled,
                })}
            >
                {children}
            </span>
        </Tooltip>
    );
}
